import "./chunk--chunk-Z7A6LSGX.vbt.js";

// src/js/helpers/ComponentConstructor.js
function initComponentOnConnectedComponentLoad(componentToInit, handleToWatch, selectorDispatch, element, dataSelect) {
  document.addEventListener(handleToWatch + " loaded", function handler() {
    const component = new componentToInit(element, dataSelect);
    if (component.init)
      component.init();
    document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
    this.removeEventListener(handleToWatch + " loaded", handler);
  });
}
function initComponentOnConnectedComponentDomEvent(componentToInit, handleToWatch, trigger, selectorDispatch, element, dataSelect) {
  document.querySelectorAll("[data-" + handleToWatch + "]").forEach(
    (elementTrigger) => elementTrigger.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    })
  );
}
function initComponentOnSelfDomEvent(componentToInit, trigger, selectorDispatch, element, dataSelect) {
  if (window.innerWidth < 768 && trigger === "mouseover") {
    initComponentOnSelfIntersection(
      componentToInit,
      selectorDispatch,
      element,
      dataSelect
    );
  } else {
    element.addEventListener(trigger, function handler() {
      const component = new componentToInit(element, dataSelect);
      if (component.init)
        component.init();
      document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
      this.removeEventListener(trigger, handler);
    });
  }
}
function initComponentOnSelfIntersection(componentToInit, selectorDispatch, element, dataSelect) {
  const component = new componentToInit(element, dataSelect);
  if (component.init) {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        component.init();
        document.dispatchEvent(new CustomEvent(selectorDispatch + " loaded"));
        observer.disconnect();
      }
    }, {
      rootMargin: "300px 0px 0px 0px"
    });
    observer.observe(element);
  }
}
function ComponentConstructor(components) {
  Object.entries(components).forEach(([selector, Component]) => {
    const dataSelect = "data-" + selector;
    const matchedElements = document.querySelectorAll("[" + dataSelect + "]");
    matchedElements.forEach((element) => {
      if (Array.isArray(Component)) {
        if (Component.filter((option) => typeof option === "string" && option.includes("url:")).length > 0) {
          const urls = Component.map((option) => typeof option === "string" && option.includes("url:") ? option.split("url:")[1] : false);
          let shouldInit = false;
          for (const url of urls) {
            if (url && window.location.href.includes(url)) {
              shouldInit = true;
            }
          }
          if (shouldInit) {
            initComponentOnSelfIntersection(
              Component[0],
              selector,
              element,
              dataSelect
            );
            return;
          }
        }
        Component.forEach((option, i) => {
          if (i === 0 || option.includes("url:"))
            return;
          if (option.includes(":")) {
            const triggerType = option.split(":")[0];
            const triggerSelector = option.split(":")[1];
            if (triggerType === "load") {
              initComponentOnConnectedComponentLoad(
                Component[0],
                triggerSelector,
                selector,
                element,
                dataSelect
              );
            } else {
              initComponentOnConnectedComponentDomEvent(
                Component[0],
                triggerSelector,
                triggerType,
                selector,
                element,
                dataSelect
              );
            }
          } else {
            initComponentOnSelfDomEvent(
              Component[0],
              option,
              selector,
              element,
              dataSelect
            );
          }
        });
        return;
      }
      initComponentOnSelfIntersection(Component, selector, element, dataSelect);
    });
  });
}

// src/global.vbt.js
window.logout = async function() {
  const res = await fetch("/account/logout/");
  if (res.status === 200) {
    location = "/account/login/?logged_out=true";
  }
};
document.addEventListener(
  "DOMContentLoaded",
  async function globalComponents() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("disableSignup")) {
      if (urlParams.get("disableSignup") == "1") {
        document.cookie = "disableSignup=1";
      }
    }
    if (document.querySelectorAll("[data-login-modal]")) {
      document.querySelectorAll("[data-login-modal]").forEach(
        (login) => login.addEventListener("click", () => {
          if (window.innerWidth < 1024) {
            document.querySelector("#account-modal--mobile").checked = true;
          } else {
            document.querySelector("#account-modal--desktop").checked = true;
          }
          if (login.hasAttribute("data-create-account")) {
            document.querySelector("#register--desktop").checked = true;
          } else if (login.hasAttribute("data-sign-in")) {
            document.querySelector("#register--desktop").checked = false;
          }
        })
      );
    }
    if (window.location.href.includes("cart=open")) {
      document.querySelector("#cart-drawer-toggle").checked = true;
    }
    handleScrollLock();
    handleSwell();
    handleYotpoStyles();
    const components = {};
    if (document.querySelector("[data-countdown]")) {
      const Countdown = await import("./chunk--Countdown-FJ7KFU2G.vbt.js");
      components["countdown"] = Countdown.default;
    }
    if (document.querySelector("[data-gwp]")) {
      const GWP = await import("./chunk--GWP-4M5QOMYK.vbt.js");
      components["gwp"] = GWP.default;
    }
    if (document.querySelector("[data-ajax-cart]")) {
      const AjaxCart = await import("./chunk--AjaxCart-DTHJ64JQ.vbt.js");
      components["ajax-cart"] = AjaxCart.default;
    }
    if (document.querySelector("[data-free-ship]")) {
      const FreeShip = await import("./chunk--FreeShip-SGZXAMXP.vbt.js");
      components["free-ship"] = FreeShip.default;
    }
    if (document.querySelector("[data-verify-password]")) {
      const VerifyPassword = await import("./chunk--VerifyPassword-XPDFJKY7.vbt.js");
      components["verify-password"] = VerifyPassword.default;
    }
    if (document.querySelector("[data-promo-bar]")) {
      const PromoBar = await import("./chunk--PromoBar-WCNRDM6Y.vbt.js");
      components["promo-bar"] = PromoBar.default;
    }
    if (document.querySelector("[data-ajaxinate]")) {
      const AjaxinateComponent = await import("./chunk--Ajaxinate-5BEN7YRK.vbt.js");
      components["ajaxinate"] = AjaxinateComponent.default;
    }
    ComponentConstructor(components);
    document.dispatchEvent(new CustomEvent("global components loaded"));
    this.removeEventListener("DOMContentLoaded", globalComponents);
  }
);
document.addEventListener(
  "global components loaded",
  async function asyncComponents() {
    const components = {};
    if (document.querySelector("[data-slider]")) {
      const Slider = await import("./chunk--Slider-IWJASN5X.vbt.js");
      components["slider"] = Slider.default;
    }
    if (document.querySelector("[data-smooth-scroll]")) {
      const SmoothScroll = await import("./chunk--SmoothScroll-A7TVKOK2.vbt.js");
      components["smooth-scroll"] = SmoothScroll.default;
    }
    if (document.querySelector("[data-intersection-change]")) {
      const ChangeOnIntersection = await import("./chunk--ChangeOnIntersection-LFYXFGY5.vbt.js");
      components["intersection-change"] = ChangeOnIntersection.default;
    }
    if (document.querySelector("[data-accordion]")) {
      const Accordion = await import("./chunk--Accordion-JHYKLMR6.vbt.js");
      components["accordion"] = Accordion.default;
    }
    if (document.querySelector("[data-sticky-cta]")) {
      const StickyCTA = await import("./chunk--StickyCTA-P2AQKVBO.vbt.js");
      components["sticky-cta"] = StickyCTA.default;
    }
    if (document.querySelector("[data-verify-form]")) {
      const VerifyForm = await import("./chunk--VerifyForm-V3JZYEFK.vbt.js");
      components["verify-form"] = VerifyForm.default;
    }
    if (document.querySelector("[data-recharge-widget]")) {
      const RechargeWidget = await import("./chunk--RechargeWidget-THMX73YF.vbt.js");
      components["recharge-widget"] = RechargeWidget.default;
    }
    if (document.querySelector("[data-yotpo-star-widget]")) {
      const YotpoStarWidget = await import("./chunk--YotpoStarWidget-MOVSX7CW.vbt.js");
      components["yotpo-star-widget"] = YotpoStarWidget.default;
    }
    if (document.querySelector("[data-tabs]")) {
      const Tabs = await import("./chunk--Tabs-CSEMNJ5D.vbt.js");
      components["tabs"] = Tabs.default;
    }
    if (document.querySelector("[data-estimated-delivery-api]")) {
      const EstimatedDelivery = await import("./chunk--EstimatedDelivery-HT3I4X62.vbt.js");
      components["estimated-delivery-api"] = EstimatedDelivery.default;
    }
    if (document.querySelector("[data-storemapper-id]")) {
      const Storemapper = await import("./chunk--Storemapper-IN54Q57Z.vbt.js");
      new Storemapper.default().init();
    }
    if (document.querySelector("[data-scroll-to]")) {
      const ScrollTo = await import("./chunk--ScrollTo-7GHXG22R.vbt.js");
      components["scroll-to"] = ScrollTo.default;
    }
    if (document.querySelector("[data-variant]")) {
      const Variant = await import("./chunk--Variant-USVEZEXW.vbt.js");
      components["variant"] = Variant.default;
    }
    ComponentConstructor(components);
    document.dispatchEvent(new CustomEvent("async components loaded"));
    this.removeEventListener("global components loaded", asyncComponents);
  }
);
document.addEventListener(
  "async components loaded",
  async function deferredComponentListeners() {
    const components = {};
    if (document.querySelector("[data-yotpo-rewards]")) {
      const YotpoRewards = await import("./chunk--YotpoRewards-6H6OJJ4G.vbt.js");
      components["yotpo-rewards"] = [
        YotpoRewards.default,
        "url:/pages/rewards"
      ];
    }
    if (document.querySelector("[data-searchspring]")) {
      const Searchspring = await import("./chunk--Searchspring-QG332CGZ.vbt.js");
      components["searchspring"] = [
        Searchspring.default,
        "mouseover",
        "url:/collections/",
        "url:/search"
      ];
    }
    if (document.querySelector("[data-filters]")) {
      const Filters = await import("./chunk--Filters-G26NZQIR.vbt.js");
      components["filters"] = Filters.default;
    }
    if (document.querySelector("[data-iframe]")) {
      const IFrame = await import("./chunk--IFrame-ULTPB7IU.vbt.js");
      components["iframe"] = [IFrame.default, "mouseover"];
    }
    if (document.querySelector("[data-range-reveal]")) {
      const RangeReveal = await import("./chunk--RangeReveal-FNVXLKF2.vbt.js");
      components["range-reveal"] = RangeReveal.default;
    }
    if (document.querySelector("[data-predictive-search]")) {
      const PredictiveSearch = await import("./chunk--PredictiveSearch-7GFQ6JWC.vbt.js");
      components["predictive-search"] = [
        PredictiveSearch.default,
        "mouseover",
        "click"
      ];
    }
    if (document.querySelector("[data-product-form]")) {
      const ProductForm = await import("./chunk--ProductForm-3NYKU7TD.vbt.js");
      components["product-form"] = [
        ProductForm.default,
        "mouseover",
        "url:/products/"
      ];
    }
    ComponentConstructor(components);
    this.removeEventListener(
      "async components loaded",
      deferredComponentListeners
    );
  }
);
document.addEventListener(
  "deferred component listeners attached",
  async function asyncComponents2() {
    const components = {};
    ComponentConstructor(components);
    document.removeEventListener(
      "deferred component listeners attached",
      asyncComponents2
    );
    this.removeEventListener("async components loaded", asyncComponents2);
  }
);
function handleScrollLock() {
  document.querySelectorAll("[data-scroll-lock]").forEach((el) => {
    el.addEventListener("change", function() {
      if (this.checked) {
        document.body.setAttribute("style", "overflow:hidden;");
      } else {
        document.body.removeAttribute("style");
      }
      if (el.id === "search-modal-toggle") {
        document.querySelector("#search").focus();
      }
      if (el.id === "account-modal--mobile") {
        document.querySelector("#account-modal--mobile--content").style.height = window.innerHeight + "px";
      }
    });
  });
}
function handleSwell() {
  document.addEventListener("swell:setup", () => {
    const { vipTier, pointsBalance } = window.Swell.Customer.getCustomerDetails();
    document.querySelectorAll("[data-yotpo-points]").forEach((el) => {
      el.innerHTML = pointsBalance.toLocaleString();
      if (el.parentElement.hasAttribute("data-hide-container")) {
        el.parentElement.style.removeProperty("display");
      }
    });
    if (!vipTier)
      return;
    let tier = vipTier.name.toLowerCase();
    if (!tier) {
      tier = "bronze";
    }
    document.querySelectorAll("[data-yotpo-tier]").forEach((el) => {
      el.innerHTML = tier;
      if (el.closest("[data-hide-container]")) {
        el.closest("[data-hide-container]").style.removeProperty("display");
      }
    });
  });
}
function handleYotpoStyles() {
  new MutationObserver(function() {
    const yotpoTitle = document.querySelector(
      ".yotpo-bottom-line .yotpo-bottom-line-left-panel.yotpo-bottom-line-score"
    );
    if (yotpoTitle) {
      yotpoTitle.style.fontFamily = "NoeDisplay";
      this.disconnect();
    }
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
}
